function useUrlParams() {
  const urlParams = new URLSearchParams(window.location.search);
  let baseUrl = urlParams.get('url')?.replace(/^(https?)\/\//, '$1://');
  const qrId = urlParams.get('id');
  const id = qrId ? Number(qrId) : null;
  const eventIdParam = urlParams.get('eventId');
  const eventId = eventIdParam && /^\d+$/.test(eventIdParam) && Number(eventIdParam) > 0
    ? Number(eventIdParam)
    : null;
  const noUser = urlParams.get('nouser');
  const token = urlParams.get('token');
  const isMePage = window.location.pathname.includes('/mepage');
  const isGenQrCodePage = window.location.pathname.includes('/generating-qr-code');
  const isMeTicketPage = window.location.pathname.includes('/meticket');
  const isMeShortLinkPage = window.location.pathname.includes('/me-short-link');

  return { baseUrl, id, eventId, noUser, token, isMePage, isGenQrCodePage, isMeTicketPage, isMeShortLinkPage };
}
export default useUrlParams;
